import React,{Component} from 'react'
import {Container, Table, Button, ButtonToolbar} from 'react-bootstrap'
import {DetailModal} from './DetailModal'
import { ToId, ToDate } from '../../../components/Shared/ViewControl'
import Header from '../../Header'

export class Detail extends Component{

    constructor (props){
        super(props)
        this.state = {items:[], itemId:0, modalShow:false, mode:0, search:''}
        this.entity='service/Detail/1'
        this.istyle = {display: 'flex', justifyContent: 'center'} 
    }

    componentDidMount(){
        //alert(JSON.stringify(this.props))
        this.Load()
    }

    componentWillUnmount() {
        this.setState({items:[]})        
    }
    
    Load() {
        this.props.global.GET(this.entity)
        .then(data => {
            this.setState({items:data, filtered:data})
            this.props.onEtat(`${this.state.items.length} rows...`)
            }
        )
        .catch(error => console.log({ error }))
    }    
    
    Delete(id) {
        this.props.global.DELETE(this.entity, id)
        .then(()=> this.Load())
    }

    modalClose =() => {
        this.setState({modalShow:false})
        this.Load()
    }

    onSearch = (value) => {
        this.setState({search:value})
        this.props.onEtat(value)
        
        this.forceUpdate();
        //alert(value)
    }

    render() {

        const filtered = this.state.items.filter(
            (item)=>{
            return (item.File+' '+item.Id).indexOf(this.state.search)>-1;
        })

        return (
            <Container style={{height: '80%', overflowY:'auto'}}>
            
        <Header lang={this.props.lang} service={'Synchronize'} account={this.props.account} onSearch={this.onSearch} />
<Table className="mt-3" striped hover bordered size="sm">
<thead>
    <tr>
        <th>Id</th>
        <th>File</th>
        <th>Syncs</th>
        <th>SizeKo</th>
        <th>Content</th>
        <th style={{width:'6rem'}}>Date</th>
        <th style={{width:'6rem'}}>
            <ButtonToolbar style={this.istyle}>
            <Button variant='primary' onClick={()=>this.setState({modalShow:true, itemId:0, mode:2})}>
            +</Button>           
            </ButtonToolbar>
        </th> 
    </tr>
</thead>

<tbody>
    {
        filtered.map(item=>
            <tr key={item.Id}>
<ToId value={item.Id} onClick={()=> this.setState({modalShow:true,itemId:item.Id,mode:0})} selelcetd={this.state.itemId}/>
<td>{item.File}</td>
<td>{item.Syncs}</td>
<td>{item.SizeKo}</td>
<td>{item.Content}</td>
<ToDate value={item.Updated} />
<td>
    <ButtonToolbar>
        <Button className="mr-2" variant="info"
        onClick={()=> this.setState({modalShow:true,itemId:item.Id,mode:1})}
        ><i className="fa fa-edit" style={this.istyle}></i></Button>

        <Button className="mr-2" variant="danger"
        onClick={()=> this.Delete(item.Id)}
        ><i className="fa fa-trash" style={this.istyle}></i></Button>
    </ButtonToolbar>
</td>
            </tr>
            )
    }
</tbody>
</Table>

{this.state.modalShow ?   
<DetailModal 
    global={this.props.global}
    entity={this.entity}
    id={this.state.itemId}
    mode={this.state.mode}
    show={true}
    onHide={this.modalClose}
/>
: null}

</Container>


        )
    }
}